import React from "react";
import styles from "./Textarea.module.scss";

export const Textarea = ({
  value,
  onChange,
  label,
  rows = 11,
  placeholder,
  smallText,
  ...props
}) => {
  return (
    <div className={styles.textareaContainer}>
      <label className={styles.label}>{label}</label>
      <textarea
        {...props}
        className={styles.textarea}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        rows={rows}
      ></textarea>
      <small>{smallText}</small>
    </div>
  );
};
